import { Grid, } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import * as Logos from '@cfa/brand-icons/logos';
import tokens from "@cfa/design-tokens";

type LogoFullProps = {
  size?: "sm" | "md" | "lg" | number;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  // When true, stacks and centers the script mark and Homestead text (Homepage).
  centered?: boolean;
};

export const LogoFull = ({
  size = 'sm',
  variant = 'h5',
  centered = false,
}: LogoFullProps) => {
  // Always stack CFA script above "Homestead" (Sidebar and home). Only centering differs.
  return (
    <Grid
      container
      direction="column"
      alignItems={centered ? 'center' : 'flex-start'}
      wrap="nowrap"
    >
      <Logos.Script
        size={size}
        color="brand-red"
        style={{ fill: tokens.color.primary.base.modes.light }}
      />
      <Typography variant={variant} color="primary">
        Homestead
      </Typography>
    </Grid>
  );
};